var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogConsoleWarning = function SvgLogConsoleWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19319_35722)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 8.74669V6.25336",
    stroke: "#FF9F0A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16683 10.9167C8.16683 11.0087 8.09221 11.0833 8.00016 11.0833C7.90812 11.0833 7.8335 11.0087 7.8335 10.9167C7.8335 10.8246 7.90812 10.75 8.00016 10.75",
    stroke: "#FF9F0A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10.75C8.09205 10.75 8.16667 10.8246 8.16667 10.9167",
    stroke: "#FF9F0A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.35267 2.75935L14.4587 11.6953C15.052 12.734 14.302 14.0267 13.106 14.0267H2.894C1.69734 14.0267 0.947338 12.734 1.54134 11.6953L6.64734 2.75935C7.24534 1.71201 8.75467 1.71201 9.35267 2.75935Z",
    stroke: "#FF9F0A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19319_35722"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
export { SvgLogConsoleWarning as ReactComponent };
export default __webpack_public_path__ + "log-console-warning.svg";